import { render, staticRenderFns } from "./GoogleRating.vue?vue&type=template&id=6f3b4619&scoped=true"
import script from "./GoogleRating.vue?vue&type=script&lang=js"
export * from "./GoogleRating.vue?vue&type=script&lang=js"
import style0 from "./GoogleRating.vue?vue&type=style&index=0&id=6f3b4619&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f3b4619",
  null
  
)

export default component.exports